import React, { useState } from "react";
import CustomModal from "../../../../components/generic/custommodal/CustomModal";
import ExistingCareCircleMembers from "./ExistingCareCircleMembers";
import { teamMemberApiResponse } from "./AddEditTeamMemberModalComponent";
import { EventType } from "../../../../service/network/utils/EventType";

const ExistingCareCircleMemberModal = ({
  isModalOpen,
  setIsModalOpen,
  existingMembers,
}) => {
  const [addedMembersMap, setAddedMembersMap] = useState({});

  const handleClose = () => {
    if (Object.keys(addedMembersMap).length) {
      teamMemberApiResponse.next({
        type: EventType.PATIENT_TEAM_MEMBER_RESPONSE,
      });
    }

    setIsModalOpen(false);
  };

  return (
    <CustomModal
      closable={true}
      isModalOpen={isModalOpen}
      footer={[]}
      closeModal={handleClose}
      title="Existing Members"
    >
      <ExistingCareCircleMembers
        existingMembers={existingMembers}
        addedMembersMap={addedMembersMap}
        setAddedMembersMap={setAddedMembersMap}
      />
    </CustomModal>
  );
};

export default ExistingCareCircleMemberModal;
